import React from "react";
import ReactDOM from "react-dom";
import { App } from "./App";
import "./index.css";

window.dataLayer = { push: (e) => null };
ReactDOM.render(<App />, document.getElementById("root"));
